import { remoteConfig } from "config/firebase";
import { fetchAndActivate, getValue } from "firebase/remote-config";

class RemoteConfigService {
  static async getBooleanValue(key) {
    return fetchAndActivate(remoteConfig).then(() => {
      return getValue(remoteConfig, key).asBoolean();
    });
  }

  static async getStringValue(key) {
    return fetchAndActivate(remoteConfig).then(() => {
      return getValue(remoteConfig, key).asString() || "";
    });
  }

  static async getJsonValue(key) {
    return fetchAndActivate(remoteConfig).then(() => {
      return JSON.parse(getValue(remoteConfig, key).asString() || "[]");
    });
  }
}
export default RemoteConfigService;
